module.exports = __webpack_public_path__ + "img/7cf0155.jpg";